<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo"
                            :range-inline="false"
                            :start-validations="validations.periodo"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.equipes"
                            @change="handleEquipeChange"
                            default-option-text="Todas"
                            label="Equipe"
                            show-default-option
                            text-field="descricao"
                            v-model="model.equipeId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="items.length > 0">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-table
                            :fields="fields"
                            :items="items"
                            :sort-by="sortBy"
                            :sort-desc="sortDesc"
                            @sort-changed="onSortChanged"
                            hide-filters
                            hide-pagination
                        >
                            <template v-slot:cell(porcentagemAtendimentoDemandaProgramada)="{ item }">
                                {{ item.porcentagemAtendimentoDemandaProgramada }}%
                            </template>

                            <template v-slot:cell(porcentagemAtendimentoDemandaEspontanea)="{ item }">
                                {{ item.porcentagemAtendimentoDemandaEspontanea }}%
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.atencaoBasica'),
            impressao: this.getConectaSusRepository('impressao.atencaoBasica'),
            relatorioAcessoCuidadoProgramado: this.getConectaSusRepository('atencaoBasica.relatorioAcessoCuidadoProgramado'),
        }

        this.load()
    },
    data() {
        return {
            form: null,
            fields: [
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                {key: 'equipeDescricao', label: 'Equipe', sortable: true},
                {key: 'usuarioNome', label: 'Profissional', sortable: true},
                {key: 'totalAtendimentoDemandaProgramada', label: 'Total de atendimentos de demanda programada', sortable: true},
                {key: 'porcentagemAtendimentoDemandaProgramada', label: 'Porcentagem de atendimentos de demanda programada', sortable: true},
                {key: 'totalAtendimentoDemandaEspontanea', label: 'Total de atendimentos de demanda espontânea', sortable: true},
                {key: 'porcentagemAtendimentoDemandaEspontanea', label: 'Porcentagem de atendimentos de demanda espontânea', sortable: true},
                {key: 'totalAtendimento', label: 'Total de atendimentos', sortable: true},
            ],
            items: [],
            model: null,
            others: {moment},
            sortBy: 'unidadeNomeFantasia',
            sortDesc: false,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioAcessoCuidadoProgramado.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                equipeId: this.model.equipeId,
                usuarioId: this.model.usuarioId,
            }

            this.setLoading()

            this.repositories.relatorioAcessoCuidadoProgramado.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.items = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.equipes = []
            this.form.usuarios = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.equipeId = null
            this.model.usuarioId = null

            this.items = []

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                equipeId: this.model.equipeId,
                usuarioId: this.model.usuarioId,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.impressao.relatorioAcessoCuidadoProgramado(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                equipeId: this.model.equipeId,
                usuarioId: this.model.usuarioId,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.exportacao.relatorioAcessoCuidadoProgramado(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.equipes = []
            this.form.usuarios = []
            this.model.infraestruturaId = null
            this.model.equipeId = null
            this.model.usuarioId = null

            this.items = []

            const request = {
                listar: 'infraestruturas',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioAcessoCuidadoProgramado.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.equipes = Object.assign(response.data.equipes)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.equipes = []
            this.form.usuarios = []
            this.model.equipeId = null
            this.model.usuarioId = null

            this.items = []

            const request = {
                listar: 'equipes',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioAcessoCuidadoProgramado.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.equipes = Object.assign(response.data.equipes)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleEquipeChange(value) {
            this.form.usuarios = []
            this.model.usuarioId = null

            this.items = []

            const request = {
                listar: 'usuarios',
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                equipeId: value,
            }

            this.setLoading()

            this.repositories.relatorioAcessoCuidadoProgramado.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.usuarios = Object.assign(response.data.usuarios))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange() {
            this.items = []
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
    },
    mixins: [error, file, repository, stringCase],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.equipes = []
                this.form.usuarios = []
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.equipeId = null
                this.model.usuarioId = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    periodo: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioAcessoCuidadoProgramado.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.equipes = Object.assign(response.data.equipes)
                        this.form.usuarios = Object.assign(response.data.usuarios)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>